import { EmployeeCardShowDefault } from 'components/molecules/EmployeeCard'
import React, { useMemo } from 'react'
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedList from 'components/atoms/ThemedList'
import _ from 'lodash'
import { dataConstants } from 'services/redux/data/constants'
import { StyleSheet, View } from 'react-native'
import { employeeConstants } from 'utils/constants/employee-constants'
import FetchCachedEmployee from 'utils/fetch/cached/FetchCachedEmployee'
import EmployeeInternal from 'scenes/home/book/_functions/EmployeeInternal'
import EmployeeExternal from 'scenes/home/book/_functions/EmployeeExternal'
import { useSelector } from 'react-redux'
import { TESTID } from '_shared/config/testID'
import { layoutStyles } from 'styles/layout'


export const renderItem = ( onPress, show, { item }, ...props ) => {
	if( _.get( item, 'kind', employeeConstants.KIND_INTERNAL ) === employeeConstants.KIND_INTERNAL ) {
		return (
			<EmployeeInternal
				item={ item }
				show={ show }
				onPress={ onPress }
			/>
		)
	}
	
	return (
		<EmployeeExternal
			item={ item }
			show={ show }
			onPress={ onPress }
		/>
	)
}

const RenderEmployeeList = ({ employees, showSelf = false, onPressEmployee = null, show = EmployeeCardShowDefault, note = null, containerStyle = {} }) => {
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	const employeesList = useMemo( () => {
		let result = _.clone( employees )
		
		if( !showSelf ) {
			result = _.filter( result, ( o ) => {
				return o.guid !== _employee.guid;
			} );
		}
		
		result = _.sortBy( result, [ (o) => {
			return o.name;
		} ] );
		
		if( showSelf ) {
			result = _.sortBy( result, [ (o) => {
				return o.guid === _employee.guid ? 0 : 1;
			} ]);
		}
		
		return result;
	}, [ showSelf, employees, _employee ] )
	
	const onItemsVisible = ( items ) => {
		const guids = items.map( o => {
			return o.item.guid;
		} )
		
		FetchCachedEmployee.fetchEasy({
			employee_guids: guids,
			details: show !== EmployeeCardShowDefault && !_.isFunction( show )
		})
	}
	
	if ( _.size( employeesList ) === 0 ) {
		return null;
	}
	
	return (
		<View
			style={[
				layoutStyles.flexOne,
				containerStyle
			]}>
			
			<ThemedBlock
				shadow
				containerStyle={ layoutStyles.flexOne }
				style={ layoutStyles.flexOne }
				testID={ TESTID.HOME.BOOK.COWORKER.EMPLOYEE_LIST.BLOCK }>
				
				<ThemedList
					data={ employeesList }
					renderItem={ renderItem.bind( this, onPressEmployee, show ) }
					style={ styles.themedList }
					estimatedItemSize={ 108 }
					scrollEnabled={ true }
					onItemsVisible={ onItemsVisible }
				/>
				
				{ note !== null && (
					{ note }
				)}
			</ThemedBlock>
		</View>
	);
}

const styles = StyleSheet.create({
	themedList: {
		paddingHorizontal: 0,
		flex: 1,
	},
})

export default RenderEmployeeList
